import React, { useEffect } from 'react';
import MasterPage from 'components/MasterPage';
import { useState } from 'react';
import { Card, Col, Container, Form, Row, Dropdown, Tabs, Tab } from 'react-bootstrap';
import { DashboardOutlined, Fullscreen, FullscreenExit, FilterList } from '@material-ui/icons';
import CnaesRequestService from 'services/cnaes-request';
import CnaeList from './CnaeList';
import './style.scss';
import ChartCuston from './ChartCuston';
import Select from 'react-select';
import collect from 'collect.js';
import ChartMap from './ChartMap';
import SelectFiscalYears from 'components/SelectFiscalYears';
import Axios from 'axios';
import { useUser } from 'models';

export default function(){
  const user = useUser();
  const [fullscreen, setfullscreen] = useState(false);

  const [fullscreenitem, setfullscreenitem] = useState(null);

  const [getvalue, setgetvalue] = useState(false);
  const [fiscalyear, setfiscalyear] = useState(user.fiscal_year.id);
  const [sortlistcnaes, setsortlistcnae] = useState('name')

  const [cnaeslist, setcnaeslist] = useState(null);
  const [cnaeslistwithvalue, setcnaeslistwithvalue] = useState(null);
  const [manufacturers, setmanufacturers] = useState({ list: [], load: true, selected: null });
  const [resales, setResales] = useState({ list: [], load: true, selected: null });

  const [filterperiod, setfilterperiod] = useState({start:"",end:""});

  const [valuebyaddressstate, setvaluesbyaddressstate] = useState({
    names: [],
    values: [],
    load: true
  });
  const [valuebyresale, setvaluebyresale] = useState({
    names: [],
    values: [],
    load: true
  });
  const [valuebymanufacturer, setvaluebymanufacturer] = useState({
    names: [],
    values: [],
    load: true
  });

  const [sectionselected, setsectionselected] = useState(null);

  useEffect(() => {
    CnaesRequestService.getList().then(({ data }) => {
      setcnaeslist(data);
      setgetvalue(true);
    })
    CnaesRequestService.getListManufacturers().then(({ data }) => {
      setmanufacturers({
        list: data.map(a => ({ value: a.id, label: a.name })),
        load: false,
        selected: null
      });
    })
    CnaesRequestService.getListResales().then(({ data }) => {
      setResales({
        list: data.map(a => ({ value: a.id, label: a.alias ?? a.name })),
        load: false,
        selected: null
      });
    })
  }, []);

  useEffect(() => {
    // token_cancel_request.charts.cancel('Não é mais de meu interesse enviar esta requisição.');
    let aux_token_cancel_request = Axios.CancelToken.source();
    // set_token_cancel_request({
    //   ...token_cancel_request,
    //   charts:aux_token_cancel_request
    // })
    getChartsValues(aux_token_cancel_request);

    return ()=>{
      aux_token_cancel_request.cancel();
    }
  }, [sectionselected])

  const requestCancel = (error) => {}

  useEffect(() => {
    async function addValueList(obj, values = null) {
      let aux = { ...obj };
      if(aux.list){
        let array_list = Object.keys(aux.list);
  
        let t = 0;
        for (let i = 0; i < array_list.length; i++) {
          const a = array_list[i];
          if (aux.list[a].type == "subclass") {
            if (values)
              aux.list[a].value = values.filter(d => d.subclass == a)[0].value;
            else
              aux.list[a].value = void 0;
  
            t += aux.list[a].value;
          } else if (aux.list[a].list) {
            aux.list[a] = await addValueList(aux.list[a], values);
  
            t += aux.list[a].value;
          }
        }
  
        aux.value = t;
        return { ...aux };
      }
      return { ...aux }
    }
    async function con(token_cancel_request) {
      try {
        let response = await CnaesRequestService.getValues('subclass', {
          params: {
            fiscal_year_id: fiscalyear,
            manufacturer_id: manufacturers.selected,
            seller_id: resales.selected,
            start:filterperiod.start,
            end:filterperiod.end,
          },
          cancelToken: token_cancel_request.token
        });
        let aux = { ...cnaeslist };
        let array_list = Object.keys(aux);
        for (let i = 0; i < array_list.length; i++) {
          const a = array_list[i];
          if (!aux[a].value && aux[a].type)
            aux[a] = await addValueList(aux[a], response.data);
          // setcnaeslistwithvalue({ ...aux });
          // setTotal(collect(aux).sum('value'));
        }
        let response_others_values = await CnaesRequestService.getOthersValues({
          params: {
            fiscal_year_id: fiscalyear,
            manufacturer_id: manufacturers.selected,
            seller_id: resales.selected,
            start:filterperiod.start,
            end:filterperiod.end,
          },
          cancelToken: token_cancel_request.token
        });
        setcnaeslistwithvalue({ 
          ...aux, 
          "Outros":{ ...aux['Outros'], value:response_others_values.data.other_values },
          "Estoque Próprio":{ ...aux['Estoque Próprio'], value:response_others_values.data.own_stock },
        });
      } catch (error) {}
    }
    let aux_token_cancel_request = Axios.CancelToken.source();
    let aux_token_cancel_request2 = Axios.CancelToken.source();
    if (getvalue && !manufacturers.load && !resales.load) {
      setcnaeslistwithvalue({ ...cnaeslist })
      con(aux_token_cancel_request);
      try {
        getChartsValues(aux_token_cancel_request2);
      } catch (error) {}
    }
    return ()=>{
      aux_token_cancel_request.cancel();
      aux_token_cancel_request2.cancel();
    }
  }, [getvalue, fiscalyear, manufacturers, resales, filterperiod]);

  const getChartsValues = (token_cancel_request) => {
    if(getvalue && !manufacturers.load && !resales.load){
      setvaluesbyaddressstate({
        names: [],
        values: [],
        load: true
      });
      setvaluebyresale({
        names: [],
        values: [],
        load: true
      });
      setvaluebymanufacturer({
        names: [],
        values: [],
        load: true
      });

      CnaesRequestService.getValuesByAddressState({
        params: {
          fiscal_year_id: fiscalyear,
          manufacturer_id: manufacturers.selected,
          seller_id: resales.selected,
          section_code: sectionselected,
          start:filterperiod.start,
          end:filterperiod.end,
        },
        cancelToken: token_cancel_request.token
      }).then(({ data }) => {
        setvaluesbyaddressstate({
          names: [...data].map(a => (a.address_state ? a.address_state : 'Sem Estado')),
          values: [...data].map(a => (a.value)),
          list: [...data],
          load: false
        })
      }).catch();
      CnaesRequestService.getValuesByResale({
        params: {
          fiscal_year_id: fiscalyear,
          manufacturer_id: manufacturers.selected,
          seller_id: resales.selected,
          section_code: sectionselected,
          start:filterperiod.start,
          end:filterperiod.end,
        },
        cancelToken: token_cancel_request.token
      }).then(({ data }) => {
        let total = 0;
        let aux = data.slice(20, data.length);
        for (let i = 0; i < aux.length; i++) {
          total += aux[i].value;
        }
        let outros = {
          total: [total],
          name: ['Outros']
        }
        if (total == 0) {
          outros = {
            total: [],
            name: []
          }
        }
        setvaluebyresale({
          names: [...[...data].slice(0, 20).map(a => (a.alias ? a.alias : a.name))],
          values: [...[...data].slice(0, 20).map(a => (a.value))],
          list: [...data],
          load: false
        })
      }).catch();
      CnaesRequestService.getValuesByManufacturers({
        params: {
          fiscal_year_id: fiscalyear,
          manufacturer_id: manufacturers.selected,
          seller_id: resales.selected,
          section_code: sectionselected,
          start:filterperiod.start,
          end:filterperiod.end,
        },
        cancelToken: token_cancel_request.token
      }).then(({ data }) => {
        let total = 0;
        let aux = data.slice(20, data.length);
        for (let i = 0; i < aux.length; i++) {
          total += aux[i].value;
        }
        let outros = {
          total: [total],
          name: ['Outros']
        }
        if (total == 0) {
          outros = {
            total: [],
            name: []
          }
        }
        setvaluebymanufacturer({
          names: [...[...data].slice(0, 20).map(a => (a.name))],
          values: [...[...data].slice(0, 20).map(a => (a.value))],
          list: [...data],
          load: false
        })
      }).catch();
    }
  }

  const fill = () => {
    let menu = document.getElementById('menu-lateral');
    let menu_1 = document.getElementById('menu-top-1');
    let menu_2 = document.getElementById('menu-top-2');
    let content_primary = document.getElementById('content-primary');
    let body = document.getElementsByTagName('body')[0];

    menu.style.transition = '0.5s';
    menu_1.style.transition = '0.5s';
    menu_2.style.transition = '0.5s';
    content_primary.style.transition = '0.5s';
    body.style.transition = '0.5s';

    if (fullscreen) {
      menu.style.transform = null;
      menu_1.style.transform = null;
      menu_2.style.transform = null;

      content_primary.style.marginLeft = '200px';
      content_primary.style.paddingTop = '120px';

      body.style.maxHeight = null;
      // body.style.overflowY = null;
      body.style.overflowX = null;

    } else {
      menu.style.transform = 'translateX(-100%)'
      menu_1.style.transform = 'translateX(-100%) translateY(-100%)';
      menu_2.style.transform = 'translateX(-100%) translateY(-120px)';

      content_primary.style.marginLeft = '0px';
      content_primary.style.setProperty("padding-top", "0px", "important");

      body.style.maxHeight = "100vh";
      // body.style.overflowY = "hidden";
      body.style.overflowX = "hidden";
    }
    setfullscreen(!fullscreen);
  }

  const renderCardChart = (key, data, margin) => {

    return (
      <Col xs={fullscreenitem == key ? 12 : 12} className="pl-2 pt-3 pr-4" style={{ position: "relative", transition: ".5s" }}>
        <Row className="pl-2">
          <Col xs="auto" className="pl-0">
            <Form.Group>
              <Form.Label>Seção</Form.Label>
              <select className="font-10 form-control"
                onChange={({ target }) => {
                  setsectionselected(target.value);
                }}
              >
                <option value="">Todas</option>
                {cnaeslist ? (
                  Object.keys(cnaeslist).map((a, k) => {
                    return <option key={k} selected={sectionselected == a ? true : false}>{a}</option>
                  })
                ) : ''}
              </select>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={fullscreenitem == key ? "7" : "12"}>
            <ChartCuston data={data} margin={margin} />
          </Col>
          {
            fullscreenitem == key ? (
              <Col style={{ height: "500px", overflowY: "auto", overflowX: "hidden" }}>
                <table className="bootstrap-table">
                  {data.list.map((a, k1) => {
                    return (
                      <tr key={k1}>
                        {Object.values(a).map((b, k2) => {
                          return <td key={k2}>{b}</td>
                        })}
                      </tr>
                    );
                  })}
                </table>
              </Col>
            ) : ''
          }
        </Row>
      </Col>
    )
  }

  function renderPeriod(){
    let fy = user.fiscal_years.filter(fy => fy.id == fiscalyear)[0]
    let options = [
      { id:7,  order:0,  name:"Julho",     year:parseInt(fy.fiscal_year)-1 },
      { id:8,  order:1,  name:"Agosto",    year:parseInt(fy.fiscal_year)-1 },
      { id:9,  order:2,  name:"Setembro",  year:parseInt(fy.fiscal_year)-1 },
      { id:10, order:3,  name:"Outubro",   year:parseInt(fy.fiscal_year)-1 },
      { id:11, order:4,  name:"Novembro",  year:parseInt(fy.fiscal_year)-1 },
      { id:12, order:5,  name:"Dezembro",  year:parseInt(fy.fiscal_year)-1 },
      { id:1,  order:6,  name:"Janeiro",   year:parseInt(fy.fiscal_year)   },
      { id:2,  order:7,  name:"Fevereiro", year:parseInt(fy.fiscal_year)   },
      { id:3,  order:8,  name:"Março",     year:parseInt(fy.fiscal_year)   },
      { id:4,  order:9,  name:"Abril",     year:parseInt(fy.fiscal_year)   },
      { id:5,  order:10, name:"Maio",      year:parseInt(fy.fiscal_year)   },
      { id:6,  order:11, name:"Junho",     year:parseInt(fy.fiscal_year)   },
    ]
    let disabled=(item,n)=>{
      if(n==-1){
        let fy = filterperiod.end;
        if(fy){
          let month = fy.split('-')[1];
          let aux = options.filter(a=>a.id.toString() == month)[0];
          return item.order > aux.order-1;
        }
        return false;
      } else {
        let fy = filterperiod.start;
        if(fy){
          let month = fy.split('-')[1];
          let aux = options.filter(a=>a.id.toString() == month)[0];
          return item.order < aux.order;
        }
        return false;
      }
    }
    return <Row style={{margin:0}}>
    <Form.Control
      as="select"
      onChange={({target}) => setfilterperiod({...filterperiod, start:target.value})}
      className="font-14 col"
      value={filterperiod.start}
      >
      <option value={""}>--</option>
      {options.map((a,k)=>{
        let value = `${a.year}-${a.id}-1`;
        return <option key={k} disabled={disabled(a,-1)} value={value}>{a.id}/{a.year}</option>
      })}
    </Form.Control>
    <Form.Control
      as="select"
      onChange={({target}) => setfilterperiod({...filterperiod, end:target.value})}
      className="font-14 col"
      value={filterperiod.end}
    >
      <option value={""}>--</option>
      {options.map((a,k)=>{
        let month = a.id+1;
        let year = a.year;
        if(month>13){
          month=1
          year=year+1
        }
        
        let value = `${year}-${month}-1`;
        return <option key={k} disabled={disabled(a,1)} value={value}>{a.id}/{a.year}</option>
      })}
    </Form.Control>
  </Row>;
  }
  
  return <>
    <Container className={fullscreen ? '' : 'mb-5'} fluid>
      <Row className="justify-content-between" style={{ marginTop: (fullscreen ? "-40px" : ".5rem") }}>
        <Col xs="auto" className="d-flex p-0">
          <DashboardOutlined className="icon-title" />
          <h5 className="title-dashboard">Dashboard CNAES</h5>
        </Col>
        <Col xs="auto" style={{ cursor: "pointer" }}>
          {fullscreen ?
            <FullscreenExit onClick={() => { fill() }} style={{ fontSize: "28px" }} />
            :
            <Fullscreen onClick={() => { fill() }} style={{ fontSize: "28px" }} />
          }
        </Col>
      </Row>
      <Card.Body className="shadow bg-white rounded text-left h-100 w-100 p-4 mt-4">
        <Row>
          <Col md="12" className="mb-1 p-4">
            <Row>
              <Col xs="3" className="pl-1 text-left">
                <Form.Group>
                  <Form.Label>Marca:</Form.Label>
                  <Select options={manufacturers.list}
                    style={{ zIndex: "2" }}
                    isLoading={manufacturers.load}
                    isClearable={true}
                    placeholder={'Selecione...'}
                    onChange={(e) => {
                      setmanufacturers({ ...manufacturers, selected: e ? e.value : null })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xs="3" className="pl-1 text-left">
                <Form.Group>
                  <Form.Label>Revenda:</Form.Label>
                  <Select options={resales.list}
                    style={{ zIndex: "2" }}
                    isLoading={resales.load}
                    isClearable={true}
                    placeholder={'Selecione...'}
                    onChange={(e) => {
                      setResales({ ...resales, selected: e ? e.value : null })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xs="2" className="text-left">
                <Form.Group>
                  <Form.Label>Ano Fiscal:</Form.Label>
                  <Form.Control
                    as="select"
                    value={fiscalyear}
                    onChange={(e) => {
                      setfiscalyear(e.target.value)
                      setfilterperiod({start:'',end:''})
                    }}
                    className="font-14"
                  >
                    <SelectFiscalYears notGetCompanyFiscalYear/>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col xs="2" className="text-left">
                <Form.Group>
                  <Form.Label>Período:</Form.Label>
                  {renderPeriod()}
                </Form.Group>
              </Col>
              <Col xs="auto" style={{ cursor: "pointer" }} className="align-self-center align-items-center mt-2">
                {fullscreen ?
                  <FullscreenExit onClick={() => { fill() }} style={{ fontSize: "28px" }} />
                  :
                  ""
                }
              </Col>
            </Row>
          </Col>
          <Col md="4" className="p-2">
            <Row>
              <Col className="text-left ml-1 mb-4">
                <Form.Label>Ordenação</Form.Label>
                <Dropdown>
                  <Dropdown.Toggle style={{ background: "transparent", border: "1px solid grey", color: "black" }} id="dropdown-basic">
                    <FilterList />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => {
                      setsortlistcnae('name')
                    }}>Nome</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      setsortlistcnae('value')
                    }}>Valor</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col xs="auto" className="text-left mb-4 mr-4">
                <Form.Label style={{textAlign: "end", width: "100%"}}>Valor Total</Form.Label>
                <p className="cnae-total-value">
                  {collect(cnaeslistwithvalue).sum('value') > 0 ?
                    parseFloat(collect(cnaeslistwithvalue).sum('value')).toLocaleString('PT-BR', { style: "currency", currency: "BRL" })
                    :
                    parseFloat('0.00').toLocaleString('PT-BR', { style: "currency", currency: "BRL" })
                  }
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs="12" style={{ height: "calc(100vh - 150px)" }}>
                <CnaeList cnaelist={cnaeslistwithvalue} sort={sortlistcnaes} />
              </Col>
            </Row>
          </Col>
          <Col md="auto"></Col>
          <Col className="p-1 mt-2">
            <Row className="pl-2 pr-3">
              <Tabs defaultActiveKey="estado" className="col-12" id="cnaesGraphs">
                <Tab eventKey="estado" title="Por Estado">
                  {/* {renderCardChart(1, valuebyaddressstate, 70)} */}
                  <Row className="pl-2">
                    <Col xs="auto" className="pl-0">
                      <Form.Group>
                        <Form.Label>Seção</Form.Label>
                        <select className="font-14 form-control"
                          onChange={({ target }) => {
                            setsectionselected(target.value);
                          }}
                        >
                          <option value="">Todas</option>
                          {cnaeslist ? (
                            Object.keys(cnaeslist).map((a, k) => {
                              return <option key={k} selected={sectionselected == a ? true : false}>{a}</option>
                            })
                          ) : ''}
                        </select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <ChartMap data={valuebyaddressstate}/>
                </Tab>
                <Tab eventKey="marca" title="Por Marca">
                  {renderCardChart(2, valuebymanufacturer, 0)}
                </Tab>
                <Tab eventKey="revenda" title="Por Revenda">
                  {renderCardChart(3, valuebyresale, 0)}
                </Tab>
              </Tabs>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Container>
  </>;

};
